export default __webpack_public_path__ + "static/media/gallery_07.ba2442f0.jpg";